import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';

export default class ServicesCMSModel implements CMSModel {
  name = '';
  weight: number;
  tag = [];
  icon: FileCMSModel = new FileCMSModel();
  primary_title = '';
  title = '';
  short_description = '';
  process_title = '';
  long_description = '';
  document_title = '';
  document_description = '';
  document_content = '';
  fee_title = '';
  fee_description = '';
  fee_content = '';

  map(obj: any): void {
    this.name = _.get(obj, 'name', '');
    this.weight = _.get(obj, 'weight', 0);
    this.tag = _.get(obj, 'tag', []);
    this.icon.map(_.get(obj, 'icon', undefined));
    this.primary_title = _.get(obj, 'translation[0].primary_title', '');
    this.title = _.get(obj, 'translation[0].title', '');
    this.short_description = _.get(obj, 'translation[0].short_description', '');
    this.process_title = _.get(obj, 'translation[0].process_title', '');
    this.long_description = _.get(obj, 'translation[0].long_description', '');
    this.document_title = _.get(obj, 'translation[0].document_title', '');
    this.document_description = _.get(obj, 'translation[0].document_description', '');
    this.document_content = _.get(obj, 'translation[0].document_content', '');
    this.fee_title = _.get(obj, 'translation[0].fee_title', '');
    this.fee_description = _.get(obj, 'translation[0].fee_description', '');
    this.fee_content = _.get(obj, 'translation[0].fee_content', '');
  }
}
